import { render } from "./LegislationView.vue?vue&type=template&id=522d1f84&scoped=true"
import script from "./LegislationView.vue?vue&type=script&lang=js"
export * from "./LegislationView.vue?vue&type=script&lang=js"

import "./LegislationView.vue?vue&type=style&index=0&id=522d1f84&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522d1f84"]])

export default __exports__